import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Rocket, Calendar } from 'lucide-react';
import { CHANGELOG } from '@/lib/changelog';
import { parseLocalDate } from '@/lib/helpers';

export default function ChangelogModal() {
  return (
    <Card className="bg-white border-0 shadow-sm">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
            <Rocket className="w-5 h-5 text-indigo-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Work Sans, sans-serif' }}>Atualizações</h2>
            <p className="text-sm text-slate-500">Histórico de versões e melhorias</p>
          </div>
          <Badge className="bg-indigo-100 text-indigo-700 text-xs font-semibold ml-1" data-testid="changelog-count">{CHANGELOG.length}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-5" data-testid="changelog-list">
          {CHANGELOG.map((entry) => (
            <div key={entry.version} className="bg-slate-50/50 rounded-2xl border border-slate-100 p-5" data-testid={`changelog-${entry.version}`}>
              <div className="flex items-center gap-3 mb-4">
                <Badge className="text-xs font-semibold bg-indigo-100 text-indigo-700">v{entry.version}</Badge>
                <span className="flex items-center gap-1.5 text-xs text-slate-500">
                  <Calendar className="w-3.5 h-3.5" />
                  Publicação em {parseLocalDate(entry.date).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
                </span>
              </div>
              <ul className="space-y-2">
                {entry.changes.map((change, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className="w-1.5 h-1.5 rounded-full bg-indigo-400 mt-1.5 flex-shrink-0" />
                    {change}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
